import { Combobox, Loader, ActionIcon } from '@mantine/core'
import { ArrowLeft, CircleAlert } from 'lucide-react'

import ContactOption from './ContactOption'

interface ContactListProps {
  selectedCarrier: {
    companyName: string
    dotNumber: string
  } | null
  contacts: Array<{
    contactId: string
    contactName?: string
    phoneNumber?: string
    email?: string
    alternativePhones?: string[]
    dotNumber?: string
    source?: string
    status?: string
    occurrenceCount?: number
  }>
  loadingCarrier: boolean
  carrierError: any
  onBackToCarriers: () => void
}

const ContactList = ({
  selectedCarrier,
  contacts,
  loadingCarrier,
  carrierError,
  onBackToCarriers,
}: ContactListProps) => {
  return (
    <>
      <div className="sticky top-0 z-10 bg-white">
        <div className="flex flex-row items-center gap-2 border-b border-gray-200 p-2">
          <ActionIcon onClick={onBackToCarriers} variant="subtle" color="gray">
            <ArrowLeft size={16} />
          </ActionIcon>
          {selectedCarrier && (
            <div className="flex flex-row items-baseline gap-1">
              <span className="text-sm font-medium text-doubleNickel-gray-700">
                {selectedCarrier.companyName}:
              </span>
              <span className="text-xs text-doubleNickel-gray-700">
                {selectedCarrier.dotNumber}
              </span>
            </div>
          )}
        </div>
      </div>

      {loadingCarrier && (
        <Combobox.Empty className="pt-3 text-center">
          <Loader size={18} color="gray" />
        </Combobox.Empty>
      )}

      {carrierError && (
        <Combobox.Empty className="flex flex-row items-center justify-center gap-2 pt-3 text-doubleNickel-warning-500">
          <CircleAlert size={14} className="stroke-doubleNickel-warning-500" />
          Error loading contacts
        </Combobox.Empty>
      )}

      {!loadingCarrier && !carrierError && contacts.length === 0 && (
        <Combobox.Empty className="pt-3 text-center">
          No contacts found for this carrier
        </Combobox.Empty>
      )}

      {contacts.map((contact, index) => (
        <ContactOption
          key={`${contact.contactId}-${index}`}
          contact={contact}
          index={index}
        />
      ))}
    </>
  )
}

export default ContactList
